import { ReviewModel } from '@assetaccountant/core/models/onboarding/reviews-model';
import { StartStatus } from '@assetaccountant/core/models/onboarding/start-status';

export const startReviews = [
  {
    body: 'It’s amazing, we calculated this year’s depreciation in just a matter of minutes!',
    name: 'Veenith Singh',
    title: 'Group Finance Operations Manager, Beca Group',
    imageFileName: 'reviews-veenith-singh',
    matchingStatuses: [StartStatus.Questions],
  } as ReviewModel,
  {
    body: "FinQuery Fixed Assets provides just the right mix of complex depreciation calculations and beautiful user interface. It's a system designed by accountants and executed perfectly.",
    name: 'Chris Emerson',
    matchingStatuses: [StartStatus.Questions],
  } as ReviewModel,
  {
    body: 'Easy to use - set up in minutes.',
    name: 'Heather Satterley',
    matchingStatuses: [StartStatus.SetupDepreciation],
  } as ReviewModel,
  {
    body: 'We love using FinQuery Fixed Assets. The time savings for every client’s depreciation entries means not only is profit increased on every job, but our additional team capacity can be directed to more valuable work.',
    name: 'Suzanne Walker',
    title: 'Director, Clear Path Accounting',
    imageFileName: 'reviews-suzanne-walker',
    matchingStatuses: [StartStatus.SetupDepreciation, StartStatus.SetupFirm],
  } as ReviewModel,
  {
    body: 'FinQuery Fixed Assets has made keeping track of fixed assets & depreciation so much easier! They have amazing customer service and respond quickly to every email. The app is very easy to use and makes my job easier.',
    name: 'Tammy W',
    matchingStatuses: [StartStatus.SetupDepreciation],
  } as ReviewModel,
  {
    body: ' We have seen a 50% efficiency gain across all the year end client work that we have moved over to FinQuery Fixed Assets.',
    name: 'Fiona',
    matchingStatuses: [StartStatus.SetupFirm],
  } as ReviewModel,
  {
    body: 'We highly recommend the use of FinQuery Fixed Assets. Our clients benefit immensely from accurate asset register records, making spreadsheet accounting (and typical errors) a thing of the past. We can easily maintain tax and accounting registers providing our clients with accurate and meaningful information. FinQuery Fixed Assets is a breeze to use, and we love that it integrates with QBO and Xero.',
    name: 'Leanne Spiteri',
    title: 'Founder, Virtue Private Advisory',
    imageFileName: 'reviews-leanne-spiteri',
    matchingStatuses: [StartStatus.SetupFirm],
  } as ReviewModel,
];
